import { GameStorageManager, Inject, Singleton } from '@denishussar/html5-game-engine';

@Singleton
export class SoundModel {
    private static _gameStorage: GameStorageManager;
    private static _loadData: any;

    public static sound_level = 1;
    public static fx = 1;
    public static music_level = 0.5;

    private _carVolume = 0.6;
    private static _collisionVolume = 1;
    private static _UI = 1;

    constructor(@Inject private _$gameStorage: GameStorageManager) {
        SoundModel._gameStorage = this._$gameStorage;
        SoundModel._loadData = JSON.parse(SoundModel._gameStorage.loadData('sound'));

        if (SoundModel._loadData) {
            const { fxLevel, musicLevel } = SoundModel._loadData;

            SoundModel.fx = parseFloat(fxLevel);
            SoundModel.music_level = parseFloat(musicLevel);

        } else {
            SoundModel._loadData = {
                fxLevel: SoundModel.fx,
                musicLevel: SoundModel.music_level,
            };
        }
    }

    public static setMusicLevel(value: number): void {
        SoundModel.music_level = value;

        SoundModel._loadData.musicLevel = value;
        SoundModel._gameStorage.saveData('sound', JSON.stringify(SoundModel._loadData));
    }

    public static setFxLevel(value: number): void {
        SoundModel.fx = value;

        SoundModel._loadData.fxLevel = value;
        SoundModel._gameStorage.saveData('sound', JSON.stringify(SoundModel._loadData));
    }

    public get carVolume(): number {
        return SoundModel.sound_level * SoundModel.fx * this._carVolume;
    }

    public get collisionVolume(): number {
        return SoundModel.sound_level * SoundModel.fx * SoundModel._collisionVolume;
    }

    public static get UI(): number {
        return SoundModel.sound_level * SoundModel.fx * SoundModel._UI;
    }

    public static  get music(): number {
        return SoundModel.sound_level * SoundModel.music_level;
    }
}
